const ENUMS = {
  ROUTE_HOME: '/',
  ROUTE_ABOUT_US: 'about-us',
  ROUTE_SERVICES: 'services',
  ROUTE_CAREERS: 'careers',
  ROUTE_CONTACT: 'contact',
  ROUTE_PROJECTS: 'projects',
  ROUTE_OUR_PEOPLE: 'our-people',
  ROUTE_LEX: 'lex',
};

export { ENUMS };
